// [jobs.listing-validation](../../../docs/product/jobs.md#jobs-listing-validation): Details and Review share the job API's text bounds. Check
// restored drafts and composed locations as well as directly typed values.
export const JOB_POSTING_LIMITS = { title: 200, location: 500, description: 4000, benefits: 4000 } as const;
export type JobPostingField = keyof typeof JOB_POSTING_LIMITS;
export const JOB_POSTING_FIELDS: JobPostingField[] = ["title", "location", "description", "benefits"];

export function jobPostingFieldError(field: JobPostingField, value: string): string | null {
  const submittedValue = field === "location" ? value : value.trim();
  if (field === "title" && submittedValue.length < 3) return "posting.jobTitleLength";
  if (submittedValue.length > JOB_POSTING_LIMITS[field]) return `posting.job${field[0].toUpperCase()}${field.slice(1)}Length`;
  return null;
}
